export function stringToNumber(string: string) {
  let stringToFormat = string
  stringToFormat = stringToFormat.replace(/\./g, '').replace(/,/g, '.')
  return Number(stringToFormat)
}
